import { useCallback, useEffect, useState } from "react";

import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { useLazyApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";

import { TutorialContext } from "./TutorialContext";

import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { FC, PropsWithChildren } from "react";

export const TutorialContextProvider: FC<PropsWithChildren> = ({ children }) => {
	const { companyInfo } = useCompanyInfo();
	const companyId = companyInfo?.Id;
	const [tutorial, setTutorial] = useState<m.Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.ActiveTutorialDto>();

	// TODO: Handle onError
	const [startBookkeepingSchool, startBookkeepingSchoolRequest] = useLazyApi(
		proxy.Accounting.BookkeepingTutorialController.StartBookkeepingTutorial.Post,
		{ onSuccess: tutorial => setTutorial(tutorial) },
	);
	const [getTutorial, getTutorialRequest] = useLazyApi(
		proxy.Accounting.BookkeepingTutorialController.GetOngoingTutorial.Get,
		{ onSuccess: tutorial => setTutorial(tutorial) },
	);

	const startTutorial = async (
		key: string,
	): Promise<m.Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.ActiveTutorialDto | undefined> => {
		if (!tutorial) {
			//ME: This feels somewhat wonky, we might be loading
			return (await startBookkeepingSchool(companyId, { TutorialKey: key })).Data;
		}
		return undefined;
	};

	const refreshTutorial = useCallback(async () => {
		if (companyId) {
			getTutorial(companyId);
		}
	}, [companyId, getTutorial]);

	useEffect(() => {
		refreshTutorial();
	}, [refreshTutorial]);

	return (
		<TutorialContext
			value={{
				startTutorial,
				currentTutorial: tutorial,
				isLoadingTutorial: startBookkeepingSchoolRequest.isLoading || getTutorialRequest.isLoading,
			}}
		>
			{children}
		</TutorialContext>
	);
};
